// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-with-dot{display:inline-flex;gap:4px;align-items:center}", "",{"version":3,"sources":["webpack://./client/view/components/TextWithPulsingDot/index.sass"],"names":[],"mappings":"AAAA,eACE,mBAAA,CACA,OAAA,CACA,kBAAA","sourcesContent":[".text-with-dot\n  display: inline-flex\n  gap: 4px\n  align-items: center"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
